import { Api } from '../api/Api';

// export const API = new Api({baseUrl:"https://test.xstat.ru/api"});
//  export const API = new Api({baseUrl:"https://localhost:7010"});
export const API = new Api();
